import PloneLink from 'components/PloneLink';
import DocumentView from './DocumentView';

import Spinner from 'components/Spinner';
import { LinkHandlerContext } from 'components/Contexts';

import ploneApi from "api/PloneApi";

export default class PanoramaTeaserView extends DocumentView {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            color: null,
            targetLkdPage: null
        }
    }

    updateTarget() {
        if(!this.props.item["referenced-lkd-content"]){
            this.setState({
                loading: false
            });
        } else {
            this.setState({
                loading: true
            });
        }
        ploneApi.fetch(this.props.item["referenced-lkd-content"]["@id"])
            .then(data => {
                this.setState({
                    targetLkdPage: data,
                });

                ploneApi.getColor(data)
                    .then(color => {
                        this.setState({
                            color: color,
                            loading: false
                        });
                    })
                    .catch(error => {
                        this.setState({
                            color: null,
                            loading: false
                        });
                    });
            });
    }

    componentDidMount() {
        super.componentDidMount();
        this.updateTarget();
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate();
        if(prevProps.item["referenced-lkd-content"] !== this.props.item["referenced-lkd-content"]) {
            this.updateTarget();
        }
    }

    render() {
        if(this.state.loading) {
            return <Spinner inline={ true }/>;
        }

        const color = this.state.color;

        return (
            <article className={ "panorama-teaser" + (color && " color-"+color+"-light color-"+color+"-border grid-breakout") }>
                <LinkHandlerContext.Consumer>
                    { context => { this.openLink = context.openLink; return null; }}
                </LinkHandlerContext.Consumer>

                { this.renderTitle() }
                { this.renderContent() }

                <PloneLink item={ this.props.item["referenced-lkd-content"] }>
                    Mehr zum Thema "{ this.state.targetLkdPage.title }" ...
                </PloneLink>
            </article>
        );
    }

}


// WEBPACK FOOTER //
// ./components/ContentViews/PanoramaTeaserView.jsx